// extracted by mini-css-extract-plugin
export default {"root":"_1AckGTSeKrNkqs4g-Yp9Hr","wrap":"Cm5xVMimiZUD3L59ziL0v","content":"_2Rart81XT_yVvDW5Y7Wf2k","contentFooter":"_30_EyJ_pGrBQCqyIjmLNP5"};